import React, { useEffect, useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import ShareButton from '../components/ShareButton';
import SearchBar, { matches, snippet } from '../components/SearchBar';

export default function Articles() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [params, setParams] = useSearchParams();
  const query = params.get('q') || '';
  // ?q=… dans l'adresse : une recherche peut se partager
  const setQuery = (v) => { const n = new URLSearchParams(params); if (v) n.set('q', v); else n.delete('q'); setParams(n, { replace: true }); };
  const shown = useMemo(() => articles.filter(a => matches(query, a.title, a.excerpt, a.tags && a.tags.split(',').map(t => '#' + t.trim()).join(' '), a.text)), [articles, query]);
  useEffect(() => {
    fetch('/api/articles')
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(d => setArticles(d))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);
  return (
    <section className="section fade-in">
      <div className="section-head">
        <h2>articles</h2>
        <span className="head-right">
          <span className="counter">{String(articles.length).padStart(2, '0')} écrits</span>
          <ShareButton variant="icon" title="Articles — Zahra's Learning" text="Les articles de Fatima-Zahra sur Zahra's Learning" />
        </span>
      </div>
      {loading ? <div className="empty-state">chargement...</div> :
       error ? <div className="empty-state">impossible de charger le contenu pour le moment — réessayez dans un instant.</div> :
       articles.length === 0 ? <div className="empty-state">rien encore ici ✎</div> : (
        <>
        <SearchBar value={query} onChange={setQuery} placeholder="Rechercher un article, un mot, un #tag…" label="Rechercher dans les articles"
          count={shown.length} total={articles.length} />
        {shown.length === 0 && (
          <div className="empty-state search-empty">
            aucun article pour « {query} »
            <button type="button" className="btn secondary" onClick={() => setQuery('')}>voir tous les articles</button>
          </div>
        )}
        <div className="articles-grid">
          {shown.map(a => {
            const inText = query && !matches(query, a.title, a.excerpt, a.tags) ? snippet(query, a.text) : '';
            return (
            <Link key={a.id} to={`/articles/${a.slug}`} className="card">
              {a.cover_image
                ? <img src={a.cover_image} alt={a.title} className="card-image" />
                : <div className="card-placeholder">✎</div>}
              <div className="card-date">{new Date(a.created_at).toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}</div>
              <h3>{a.title}</h3>
              <p className="card-excerpt">{a.excerpt}</p>
              {inText && <p className="search-snippet">« {inText} »</p>}
              {a.tags && (
                <div className="card-tags">
                  {a.tags.split(',').map((t, i) => (
                    <button key={i} type="button" className="card-tag card-tag-btn" title={`Voir les articles #${t.trim()}`}
                      onClick={(e) => { e.preventDefault(); e.stopPropagation(); setQuery('#' + t.trim()); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
                      #{t.trim()}
                    </button>
                  ))}
                </div>
              )}
            </Link>
            );
          })}
        </div>
        </>
      )}
    </section>
  );
}
